export const getAncestorIds = (organizations, orgId) => {
	const ids = new Set([orgId]);
	let current = (organizations || []).find(o => o.id === orgId || o.uid === orgId);
	while (current?.parent) {
		ids.add(current.parent);
		const parentId = current.parent;
		current = (organizations || []).find(o => o.id === parentId || o.uid === parentId);
	}
	return ids;
};

export const getEligibleOrgIds = (organizations, prefix) => {
	const eligibleOrgIds = new Set();
	(organizations || [])
		.filter(o => o.activeDirectoryCode?.startsWith(prefix))
		.forEach(org => getAncestorIds(organizations, org.id || org.uid).forEach(id => eligibleOrgIds.add(id)));
	return eligibleOrgIds;
};

export const isEnabledForOrganizationPrefix = (organizations, currentUser, prefix, accessPermissions, permissionsShouldMatchOrganization) => {
	if (!prefix || !organizations?.length || !currentUser?.organizationReadPermisions?.length) return !prefix;
	const eligibleOrgIds = getEligibleOrgIds(organizations, prefix);
	if (permissionsShouldMatchOrganization && accessPermissions?.length) {
		return currentUser.readPermissions?.some(rp => eligibleOrgIds.has(rp.organization) && accessPermissions.some(ap => rp.actionPermissions?.includes(ap))) ?? false;
	}
	return currentUser.organizationReadPermisions.some(id => eligibleOrgIds.has(id));
};
